import React, { useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { useField } from 'formik';
import {
  CheckboxField,
  CheckboxFieldProps,
} from 'components/checkbox-field/checkbox-field';
import { pick } from 'utils/pick';

type FormItemCheckboxFieldProps = Omit<
  CheckboxFieldProps,
  'value' | 'onChange'
>;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    error: {
      color: theme.palette.error.main,
      fontWeight: 'normal',
      height: '2em',
    },
  })
);

export function FormItemCheckboxField(props: FormItemCheckboxFieldProps) {
  const classes = useStyles();

  type TValue = boolean;

  const [field, meta, helpers] = useField<boolean>(props.name);

  const value: TValue = field.value || false;

  const handleChange = useCallback(
    (value: TValue) => {
      helpers.setValue(value);
    },
    [helpers]
  );

  const innerProps = pick(props, 'label', 'name', 'disabled');

  return (
    <>
      <div className={classes.error}>{meta.error}</div>
      <CheckboxField value={value} onChange={handleChange} {...innerProps} />
    </>
  );
}
